import React from "react"
import PropTypes from "prop-types"
import "./marketing.scss"
import "./sky-marketing.scss"
import Button from "../shared/button/text-button"
import Mobile from "images/splashScreens/sky-mobile.png"
import Tv from "images/splashScreens/sky-tv.png"
import Broadband from "images/splashScreens/sky-broadband.png"

const MarketingSky = ({ handleButtonClick }) => (
  <div className="marketing-page">
    <div className="marketing-page--banner">
      <div className="marketing-page--banner--heading">
        <h1>Get ultimate entertainment, wherever you are</h1>{" "}
        <div className="marketing-page--banner--heading--image-container">
          <img className="border" src={Tv} alt="" />
          <img className="border" src={Mobile} alt="" />
          <img className="border" src={Broadband} alt="" />
        </div>
      </div>
      <div className="marketing-page--banner--tiles"></div>
    </div>
    <div className="marketing-page--extras marketing-page--sky">
      <div className="thumbnailContainer">
        <div className="create-border">
          <p>
            Open up a <span className="bold">world of entertainment</span>
          </p>
          <ul>
            {" "}
            <li>
              Start with Sky Entertainment, for the latest shows everyone is
              talking about
            </li>
            <li>
              Including the Golden Globes award-winning Sky Original series,
              Chernobyl
            </li>
            <li>Then add Sky Sports, Sky Cinema, ids TV channels & more</li>
          </ul>
        </div>
        <div className="create-border">
          <p>
            <span className="bold">Superfast</span> Sky Broadband
          </p>
          <ul>
            <li>Enjoy our fastest average download speeds of 59Mbps</li>
            <li>Totally unlimited to keep the whole house online</li>
            <li>Perfect for streaming and gaming</li>
          </ul>
        </div>
        <div className="create-border">
          <p>
            <span className="bold">Sky Mobile deals</span>
          </p>
          <ul>
            <li>Save £216 on iPhone 11, now £32pm with 3GB of data</li>
            <li>
              Enjoy unlimited streaming on Sky apps without using your data
            </li>
            <li>
              Switch to our award-winning network with 99% network coverage
            </li>
          </ul>
        </div>{" "}
      </div>
    </div>
    <div className="marketing-button-container">
      <Button text="Continue" onClick={handleButtonClick} />
    </div>
  </div>
)

MarketingSky.propTypes = {
  handleButtonClick: PropTypes.func.isRequired
}

export default MarketingSky
